import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import PhoneLink from 'components/common/PhoneLink'
import PrintButton from 'components/common/PrintButton/PrintButton'
import Mixin from 'components/common/Mixin'
import Section from '../../../Section'
import {
  SCHEDULE_AN_APPOINTMENT_TITLE_FIRST_PART,
  SCHEDULE_AN_APPOINTMENT_TITLE_SECOND_PART,
  APPOINTMENT_SCHEDULE_TITLE
} from './constants'

const AppointmentIsNotEnable = ({
  phoneNumber,
  isCheckout = false
}) =>
  <Section title={ APPOINTMENT_SCHEDULE_TITLE } isCheckout={ isCheckout } icon="calendar-red">
    <InfoBanner noicon>
      { SCHEDULE_AN_APPOINTMENT_TITLE_FIRST_PART }
      <InfoBannerPhoneLink number={ phoneNumber } />
      { SCHEDULE_AN_APPOINTMENT_TITLE_SECOND_PART }
    </InfoBanner>
    <PrintAndEmailButttons>
      <PrintButton full="mobile" stacked="mobile" data-printless button>
        Print Quote
      </PrintButton>
    </PrintAndEmailButttons>
  </Section>


AppointmentIsNotEnable.propTypes = {
  isCheckout: PropTypes.bool,
  phoneNumber: PropTypes.string
}

export default AppointmentIsNotEnable


const PrintAndEmailButttons = styled.div`
  text-align: center;
`

const InfoBanner = styled.div`
  margin: 0 auto 45px;
  text-align: center;
  max-width: 810px;
  ${Mixin.font.GothamBold(14)}
`

const InfoBannerPhoneLink = styled(PhoneLink)`
  ${Mixin.font.GothamBold(14)}
`
